import React, { useMemo } from "react";
import { CircularProgress } from "@mui/material";

import { useGeneralCommentsSelector, useGeneralLoadingSelector } from "../../../store";
import { ICommentParent, IGeneralComments } from "../../../store/types";
import { Group } from "../Group/Group";
import { ISectionBody } from "../Section/Section";

export const General: React.FC<ISectionBody> = ({ findTargetRef }) => {
  const generalComments: IGeneralComments = useGeneralCommentsSelector();
  const generalLoading: boolean = useGeneralLoadingSelector();

  const groups = useMemo(() => {
    const commentsArray: ICommentParent[] = Object.values(generalComments);
    if (!commentsArray.length) {
      return <div className="comments__no-groups flex-row-fs-fc">There are no comments yet</div>;
    }

    return <Group findTargetRef={findTargetRef} comments={commentsArray} />;
  }, [generalComments]);

  return (
    <>
      {generalLoading ? (
        <div className="flex-row-fc-fc">
          <CircularProgress size={200} />
        </div>
      ) : (
        groups
      )}
    </>
  );
};
